<section class="why-ketto">
  <div class="container">
    <h2>Why Ketto?</h2>
    <div class="row d-lg-none d-md-none d-sm-none d-block text-center">
      <div *ngFor="let item of whyObject" class="col-lg-12 col-md-12 col-12 content-wrapper row p-0 ml-0">
        <div class="col-lg-6 col-sm-12 p-0">
          <div [class]="item.imageClass" data-bg="/assets/images/homepage/why-ketto.png?w=auto"></div>
        </div>
        <div class="col-lg-6 col-sm-12 p-0">
          <div class="hr"></div>
          <div class="content-area">
            <span class="text">{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="d-lg-block d-md-block d-sm-block d-none">
      <div class="row">
        <div *ngFor="let item of whyObject" class="col-lg-3 col-md-3 p-0">
          <div [class]="item.imageClass" data-bg="/assets/images/homepage/why-ketto.png?w=auto"></div>
          <div class="hr"></div>
          <div class="content-area">
            <span class="text">{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>